import React from 'react';

import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';

import {
  appSwitcherPopoutContainerCss
} from 'static/three-oh/src/components/GlobalLayout/GlobalLayoutV2/NavigationBar/AppSwitcherMenu/AppSwitcherPopout/AppSwitcherPopout.styles';
import {
  PopoutRow
} from 'static/three-oh/src/components/GlobalLayout/GlobalLayoutV2/NavigationBar/AppSwitcherMenu/PopoutRow';
import {
  FormativeLogo
} from 'static/three-oh/src/components/GlobalLayout/GlobalLayoutV2/NavigationBar/AppSwitcherMenu/PopoutRow/assets/FormativeLogo';
import {
  titleCss
} from 'static/three-oh/src/components/GlobalLayout/GlobalLayoutV2/NavigationBar/AppSwitcherMenu/PopoutRow/PopoutRow.styles';
import {isProductionEnvironment, isStagingEnvironment} from 'static/three-oh/utils/environment';

import {getUserProperties} from '../../../../../../modules/selectors/userSelectors';

const defaultTitleProps = {title: PropTypes.string.isRequired};
const DefaultTitleComponent = ({title}) => <div className={titleCss}>{title}</div>;
DefaultTitleComponent.propTypes = defaultTitleProps;


const appSwitcherPropTypes = {
  setIsOpen: PropTypes.func.isRequired,
};
const AppSwitcherPopout = ({setIsOpen}) => {
  const {
    canSeeFormative,
    canSeeEverwrite,
  } = useSelector((state) => getUserProperties(state));

  const onKeyDown = ({key}) => {
    if (key === 'Escape') {
      setIsOpen(false);
    }
  };


  const getEverwriteUrl = () => {
    if (canSeeEverwrite) {
      if (isStagingEnvironment()) {
        return 'https://writing.app.staging.newseladev.com';
      } else if (isProductionEnvironment()) {
        return 'https://writing.app.newsela.com';
      } else {
        return 'https://writing.app.dev.newseladev.com';
      }
    } else {
      return 'https://newsela.com/about/products/writing/';
    }
  };

  return (
    <ul className={appSwitcherPopoutContainerCss} data-testid="app-switcher-menu">
      {canSeeFormative && (
        <PopoutRow
          label="Go to Formative by Newsela"
          onKeyDown={onKeyDown}
          dataQASelector="global-nav-app-switcher-formative"
          href="https://app.formative.com/home"
          TitleComponent={<FormativeLogo id="formative" ariaLabel="Formative by Newsela" />}
          description="An interactive and collaborative assessments app with real-time feedback and progress tracking."
        />
      )}

      <PopoutRow
        label="Go to Newsela Writing"
        onKeyDown={onKeyDown}
        dataQASelector="global-nav-go-to-everwrite"
        href={getEverwriteUrl()}
        TitleComponent={<DefaultTitleComponent title="Newsela Writing" />}
        description="Your assistant to help students become confident writers."
      />
    </ul>
  );
};

AppSwitcherPopout.propTypes = appSwitcherPropTypes;
AppSwitcherPopout.displayName = 'AppSwitcherPopout';
export {AppSwitcherPopout};
